<div class="modal-header">
  <div tabindex="0" ngbAutofocus class="modal-title h5">Class Recording Request</div>
  <button type="button" class="btn-close" aria-label="Close" [disabled]="isSubmitting" (click)="activeModal.dismiss('cross click')"></button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="row mb-3">
      <div class="col">
        You will receive a copy of the email that is sent to the professor as well as a copy of the final approval
        or denial of the request. <strong>Please note that IT Academic Technologies must receive faculty approval at least
        2 business days prior to the class being recorded.</strong>
      </div>
    </div>

    <text-input [(obj)]="request" prop="location"
                label="Location" [labelCols]="allLabelCols"
                [typeaheadList$]="classroomList$ | typeaheadBinder : this"
                [focusOpenTypeahead]="true"
                [isDisabled]="!(classrooms$ | async)"
                [requireTypeaheadSelection]="true"
                [updateValue]="request.location"></text-input>

    <date-time [labelCols]="allLabelCols"
               [(obj)]="request" prop="date"
               min="{{recordingMinDate}}" max="{{section.EndDate}}"
               label="Recording Date" [allowTime]=false
               placeholder="Select a date"></date-time>

    <text-input [(obj)]="request" prop="message"
                label="Message to Instructor" [labelCols]="12"
                [mode]="inputMode.TextArea"></text-input>

  </div>
</div>
<div class="modal-footer">
    @if (submit$ | async) {}
    <button type="button" class="btn btn-primary" [disabled]="request.hasErrors || isSubmitting" (click)="submit()">
        Submit @if (isSubmitting) {<i class="fa-solid fa-circle-notch fa-spin ms-1"></i>}
    </button>

    <button type="button" class="btn btn-outline-secondary" [disabled]="isSubmitting" (click)="activeModal.dismiss('close')">Close</button>
</div>
